module.exports = __webpack_public_path__ + "static/img/img-5.28502ac1.png";